// Update page title and header
import React from "react";

const Title = (props) => {
  document.title = props.title + " - Long Now";
  return <h2 className="component-title">{props.title}</h2>;
};
export default Title;
